import _ from 'lodash';

import React, { Component } from 'react';

import { browserHistory } from 'react-router';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';

import { fetchRecentBookings } from 'actions/bookingActions';
import { getIssueTypes } from 'actions/issueTypeActions';
import { createOrUpdateIssue } from 'actions/issueActions';

import DropdownField from 'components/DropdownField';
import Loading from 'components/Loading/Loading';
import { prettyAppointmentTimeLocalized } from 'utils/timeUtils';

import './style.css';

const validate = formProps => {
  const errors = {};

  if (!formProps.issueTypeId) {
    errors.issueTypeId = 'Issue type required';
  }

  if (!formProps.appointmentId) {
    errors.appointmentId = 'Booking selection required';
  }

  return errors;
};

class ReportIssue extends Component {
  constructor() {
    super();
    this._bookingsHash = {};
  }

  componentWillMount() {
    this.props.getIssueTypes();
    if (this.props.user.id) {
      this.props.fetchRecentBookings();
    }
  }

  handleFormSubmit = (values) => {
    const issueTypeId = parseInt(values.issueTypeId, 10);
    const appointmentId = parseInt(values.appointmentId, 10);
    const issueData = {
      issueTypeId,
      appointmentId,
      teacherId: this._bookingsHash[appointmentId].teacherId
    };
    const issueType = _.find(this.props.issueTypes.issueTypes, { id: issueTypeId });
    this.props.createOrUpdateIssue(issueData, issueType, browserHistory);
  }

  error = () => {
    if (this.props.bookings.periodBookingsStatus === 'FAIL') {
      return this.props.bookings.error;
    }
    if (this.props.issueTypes.status === 'FAIL') {
      return this.props.issueTypes.error;
    }
    return null;
  }

  isLoading = () => {
    return (
      this.props.bookings.periodBookingsStatus === 'INIT' ||
      this.props.bookings.periodBookingsStatus === 'LOADING' ||
      this.props.issueTypes.status === null ||
      this.props.issueTypes.status === 'LOADING'
    );
  }

  renderBookingsDropdown() {
    if (this.props.bookings.periodBookings.length === 0) {
      return <div>You have no bookings</div>;
    }

    const opts = _.map(this.props.bookings.periodBookings, booking => {
      return {
        label: `${booking.teacher.name} - ${prettyAppointmentTimeLocalized(booking.startTime, booking.studentTz)}`,
        value: booking.id
      };
    });

    this._bookingsHash = {};
    _.each(this.props.bookings.periodBookings, booking => {
      this._bookingsHash[booking.id] = booking;
    });

    const aid = this.props.location.query.aid ? parseInt(this.props.location.query.aid, 10) : null;
    return (
      <Field
        name="appointmentId"
        component={DropdownField}
        options={opts}
        defaultValue={aid || undefined}
        placeholder="Which booking did you have a problem with?"
      />
    );
  }

  render() {
    if (this.props.user.id && this.props.bookings.periodBookingsStatus === 'INIT') {
      this.props.fetchRecentBookings();
    }

    const {
      handleSubmit, submitting, invalid, pristine
    } = this.props;
    const error = this.error();

    let bookingsDropdown;
    if (!error && !this.isLoading()) {
      bookingsDropdown = this.renderBookingsDropdown();
    }

    return (
      <div className="ReportIssue d-flex justify-content-center">
        <div className="card mb-3 mt-4">
          <h2>Report a Problem</h2>

          {error && (
            <p className="error">{error.message || 'An unexpected problem was experienced'}</p>
          )}

          {!error && this.isLoading() && <Loading />}

          {!error && !this.isLoading() && (
            <form onSubmit={handleSubmit(this.handleFormSubmit)}>
              <div className="mt-4">{bookingsDropdown}</div>
              <div className="radio-group mt-4">
                {this.props.issueTypes.issueTypes.map(issueType => (
                  <div key={issueType.id}>
                    <label>
                      <Field
                        name="issueTypeId"
                        component="input"
                        type="radio"
                        value={issueType.id.toString()}
                      />{' '}
                      {issueType.description}
                    </label>
                  </div>
                ))}
              </div>
              <div className="mt-4">
                <button
                  className="btn btn-primary"
                  type="submit"
                  disabled={submitting || pristine || invalid}
                >
                  Next
                </button>
              </div>
              {this.props.issues.status === 'FAIL' && (
                <div className="mt-4">
                  {this.props.issues.error.message === 'already-reported' ? (
                    <p className="error">
                      Our records indicate that you have already reported an issue for this
                      appointment. Please reach out to customer support at{' '}
                      <a href="mailto:help@rypeapp.com">help@rypeapp.com</a> if you believe this is
                      a mistake.{' '}
                    </p>
                  ) : (
                    <p className="error">
                      {this.props.issues.error.message || 'An unexpected problem was experienced'}
                    </p>
                  )}
                </div>
              )}
            </form>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, props) {
  const aid = _.get(props, 'location.query.aid', null);
  return {
    initialValues: { appointmentId: aid ? parseInt(aid, 10) : null },
    user: state.user.profile,
    bookings: state.bookings,
    issueTypes: state.issueTypes,
    issues: state.issues
  };
}

export default compose(
  connect(
    mapStateToProps,
    {
      fetchRecentBookings,
      getIssueTypes,
      createOrUpdateIssue
    }
  ),
  reduxForm({
    form: 'createIssueForm',
    enableReinitialize: true,
    validate
  })
)(ReportIssue);



// WEBPACK FOOTER //
// ./src/pages/student/ReportIssue/index.js